export const UpNextCalendarEventsLoaderScenarioId = 'TimePanelUpNextCalendarCacheId';
